module.exports = __webpack_public_path__ + "img/img-53.834765d3.png";